import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import MKBadge from "components/MKBadge";
import MKTypography from "components/MKTypography";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";

const projects = [
  {
    video: "https://carver-uat-test.s3.ap-south-1.amazonaws.com/video1.mp4",
    // brandLogo: "/logos/motorola.png",
    title: "Peach Collection",
  },
  {
    video: "https://carver-uat-test.s3.ap-south-1.amazonaws.com/video2.mp4",
    // brandLogo: "/logos/motorola.png",
    title: "AI X Art Campaign",
  },
  {
    video: "https://carver-uat-test.s3.ap-south-1.amazonaws.com/video3.mp4",
    // brandLogo: "/logos/motorola.png",
    title: "CGI Campaign",
  },
];

export default function LatestWorkCarousel() {
  return (
    <MKBox component="section" py={2}>
      {/* <h2
        style={{
          color: "#fff",
          fontSize: "38px",
          fontWeight: "700",
          marginLeft: "5vw",
          marginBottom: "40px",
        }}
      >
        Our Latest Work
      </h2> */}

      <Container>
        <Grid
          container
          item
          xs={12}
          lg={6}
          flexDirection="column"
          alignItems="center"
          sx={{ textAlign: "center", my: 6, mx: "auto", px: 0.75 }}
        >
          <MKBadge
            variant="contained"
            color="info"
            badgeContent="WORK THAT SPEAKS"
            container
            sx={{ mb: 2 }}
          />
          <MKTypography variant="h2" fontWeight="bold">
            Our Latest Work
          </MKTypography>
          <MKTypography variant="body1" color="text">
            From concept to screen — a glimpse into our crafted campaigns.
          </MKTypography>
        </Grid>
      </Container>

      <Swiper
        slidesPerView={1.2}
        spaceBetween={20}
        grabCursor
        loop
        autoplay={{ delay: 2500, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        breakpoints={{
          768: { slidesPerView: 2.2 },
          1024: { slidesPerView: 3 },
        }}
        modules={[Autoplay, Pagination]}
        style={{ paddingLeft: "5vw" }}
      >
        {projects.map((item, index) => (
          <SwiperSlide key={index}>
            <div
              style={{
                width: "100%",
                height: "460px",
                borderRadius: "22px",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <video
                src={item.video}
                autoPlay
                muted
                loop
                playsInline
                preload="metadata"
                poster={item.poster}
                controls={false}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
              ></video>

              {/* Text Overlay */}
              {/* <div
                style={{
                  position: "absolute",
                  bottom: "22px",
                  left: "22px",
                  color: "#fff",
                }}
              >
                <img
                  src={item.brandLogo}
                  alt="logo"
                  style={{ width: "120px", marginBottom: "6px" }}
                />
                <span style={{ fontSize: "20px", fontWeight: "600" }}>
                  {item.title}
                </span>
              </div> */}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </MKBox>
  );
}
